import React, {useEffect, useMemo} from "react";
import {OutlinedDropdown} from "../../../../../../../../components/base/dropdown/outlined_dropdown";
import useIndustry from "../../../../../../../../hooks/use-industry";
import LoadingLottieAnimation from "../../../../../../../../components/app-specific/lottie-animations/loading";

const UserHomepageControlPanelComponentCreateCategory = ({
                                                             add,
                                                             categories: existingCategories,
                                                             updating,
                                                         }) => {
    const {
        industries,
        categoriesOfFetchedIndustry,
        cachedIndustry,
        fetchedIndustry,
        fetchIndustry,
        loadingIndustries,
        hasNoIndustries
    } = useIndustry();

    const existingIds = useMemo(() => existingCategories?.map(e => e.id) ?? [], [existingCategories])
    const categories = useMemo(() => categoriesOfFetchedIndustry?.filter(e => !existingIds.includes(e.id)), [categoriesOfFetchedIndustry, existingIds])

    /**
     * Automatically fetches the cached industry when the component is mounted
     */
    useEffect(() => {
        if (!cachedIndustry?.id)
            return;
        void fetchIndustry({industryId: cachedIndustry.id});
    }, [cachedIndustry?.id, fetchIndustry]);

    /**
     * Invokes the appropriate controller callback for the adding a new content to a component.
     * @param {any} category
     */
    const addNewCategory = (category) => {
        add(category);
    }

    const selectIndustry = (industry) => {
        fetchIndustry({industryId: industry.id}).then();
    }

    return (
        <>
            <div className={'mx-2 d-flex flex-column '} style={{gap: 8}}>
                {
                    industries.length > 1 &&
                    <OutlinedDropdown
                        fullWidth
                        value={fetchedIndustry?.id}
                        disabled={updating}
                        onChange={selectIndustry}
                        label={'Industry'}
                        SelectProps={{
                            renderValue: (e) => industries.find(i => i.id === e)?.title ?? '',
                        }}
                        data={industries.map(e => ({
                            value: e?.id,
                            label: e.title,
                            id: e.id,
                        }) ?? [])}
                    />
                }
                {
                    hasNoIndustries && !loadingIndustries &&
                    <p className={'text-sm grey-3 font-weight-semi-bold mb-3'}>
                        No industries found. Please add an industry or contact your administrator.
                    </p>
                }
                {
                    loadingIndustries &&
                    <LoadingLottieAnimation width={'80%'}/>
                }
                {
                    !loadingIndustries && !hasNoIndustries &&
                    <OutlinedDropdown
                        fullWidth
                        value={''}
                        disabled={updating}
                        onChange={addNewCategory}
                        label={'New category'}
                        data={categories.map(e => ({
                            value: e,
                            label: e.title,
                            id: e.id,
                        }) ?? [])}
                    />
                }
            </div>
        </>
    )
}

export default UserHomepageControlPanelComponentCreateCategory;
